import React from 'react';

/**
 * Recalculates "contain" dimensions for a lightbox image so it fills
 * 90vw × 90vh while keeping its aspect ratio, then sets those
 * dimensions directly on the element so the inline-flex wrapper hugs it.
 */
function sizeImage(img: HTMLImageElement) {
  const { naturalWidth, naturalHeight } = img;
  if (!naturalWidth || !naturalHeight) return;

  const maxW = window.innerWidth * 0.9;
  const maxH = window.innerHeight * 0.9;
  const scale = Math.min(maxW / naturalWidth, maxH / naturalHeight);

  img.style.width = `${Math.round(naturalWidth * scale)}px`;
  img.style.height = `${Math.round(naturalHeight * scale)}px`;
}

/**
 * onLoad handler for lightbox images.
 * Sizes the image immediately and attaches a resize listener so the
 * image rescales live when the browser window changes size.
 * Cleans up automatically when the image is removed from the DOM.
 */
export function handleGalleryImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
  const img = e.currentTarget;
  if (!img.naturalWidth || !img.naturalHeight) return;

  sizeImage(img);

  const onResize = () => sizeImage(img);
  window.addEventListener('resize', onResize);

  const observer = new MutationObserver(() => {
    if (!img.isConnected) {
      window.removeEventListener('resize', onResize);
      observer.disconnect();
    }
  });
  observer.observe(img.parentElement || document.body, { childList: true });
}
